import { render, staticRenderFns } from "./Blacklist.vue?vue&type=template&id=26bc2c04&scoped=true"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"
import style0 from "./Blacklist.vue?vue&type=style&index=0&id=26bc2c04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bc2c04",
  null
  
)

export default component.exports